import { render, staticRenderFns } from "./CarouselPagination.vue?vue&type=template&id=06fe7f80&"
import script from "./CarouselPagination.ts?vue&type=script&lang=ts&"
export * from "./CarouselPagination.ts?vue&type=script&lang=ts&"
import style0 from "./CarouselPagination.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports